import React from 'react';
import Container from '../layout/container';
import InfoBannerSC from './info-banner.styled';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const InfoBanner = (props) => {
  const { children, className, contentClassName, isExtended } = props;
  const customClass = classNames({ [className]: className !== '' });
  const contentClass = classNames({ [contentClassName]: contentClassName !== '' });

  return (
    <InfoBannerSC className={customClass} isExtended={isExtended}>
      {isExtended ? children : <Container className={contentClass}>{children}</Container>}
    </InfoBannerSC>
  );
};

InfoBanner.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

InfoBanner.defaultProps = {
  className: '',
};

export default InfoBanner;
